import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import cronstrue from "cronstrue";
import { isNumber } from "./MathHelpers";
dayjs.extend(tz);
dayjs.extend(utc);
dayjs.extend(tz);
export var DateOrdinal = function (d) {
    if (d > 3 && d < 21)
        return "th";
    switch (d % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
export var mapIsoToLocal = function (ele) {
    if (ele === undefined || ele === "") {
        return "";
    }
    var date = ele;
    date = new Date(date);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }
    date = month + "-" + dt + "-" + year;
    return date;
};
export function timeConverter(UNIX_timestamp, dateFormat, timeFormat) {
    var timeStampMilli = UNIX_timestamp.length === 10
        ? parseInt(UNIX_timestamp) * 1000
        : parseInt(UNIX_timestamp);
    var parsedDate = dayjs(timeStampMilli);
    return parsedDate.format(dateFormat + " " + timeFormat);
}
export function getDateXDaysAgo(numOfDays, date) {
    if (date === void 0) { date = new Date(); }
    var daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() - numOfDays);
    daysAgo.setHours(0, 0, 0, 0);
    var result = daysAgo.toLocaleString("sv-SE").replace(",", "");
    return result;
}
export var getTimeZoneInHours2 = function () {
    var timezoneOffset = new Date().getTimezoneOffset();
    var offset = Math.abs(timezoneOffset);
    var offsetOperator = timezoneOffset < 0 ? "+" : "-";
    var offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    var offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return "".concat(offsetOperator).concat(offsetHours, ":").concat(offsetMinutes);
};
export var getTimeZoneInHours = function () {
    var timezoneOffset = new Date().getTimezoneOffset();
    var offset = Math.abs(timezoneOffset);
    //%2B - '+', because these are sent in query params in API URL
    var offsetOperator = timezoneOffset < 0 ? "%2B" : "-";
    var offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    var offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return "".concat(offsetOperator).concat(offsetHours, ":").concat(offsetMinutes);
};
export function getTimeZoneInISTFixed(timestamp) {
    if (!timestamp)
        return "";
    try {
        var _a = timestamp.replace("Z", "").split("T"), date = _a[0], timeWithMs = _a[1];
        var time = timeWithMs.split(".")[0]; // drop existing ms
        return "".concat(date, "T").concat(time, ".000+05:30");
    }
    catch (e) {
        console.error("Invalid timestamp:", timestamp);
        return timestamp;
    }
}
export function getTimezoneName(date) {
    var today = new Date(date);
    var short = today.toLocaleDateString(undefined);
    var full = today.toLocaleDateString(undefined, { timeZoneName: "long" });
    // Trying to remove date from the string in a locale-agnostic way
    var shortIndex = full.indexOf(short);
    if (shortIndex >= 0) {
        var trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
        // by this time `trimmed` should be the timezone's name with some punctuation -
        // trim it from both sides
        return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, "");
    }
    else {
        // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
        return full;
    }
}
export var getMonthsBetweenDates = function (startDate, endDate) {
    startDate = new Date(startDate).setDate(1);
    endDate = new Date(endDate).setDate(1);
    var months = [];
    var currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        var monthNum = currentDate.toLocaleString("default", {
            month: "numeric",
        });
        var monthYearString = "".concat(currentDate.getFullYear(), "/").concat(monthNum < 10 ? "0" : "").concat(monthNum);
        months.push(monthYearString);
        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return months;
};
export var isNumberValidBetweenDates = function (startDate, endDate, number) {
    if (number < 1 || number > 31) {
        return false;
    }
    var startDt = new Date(new Date(startDate).setHours(0, 0, 0, 0)), endDt = new Date(new Date(endDate).setHours(0, 0, 0, 0));
    if (startDt == "Invalid Date" || endDt == "Invalid Date") {
        return false;
    }
    var months = getMonthsBetweenDates(startDt, endDt);
    var isValid = false;
    for (var i = 0; i < months.length; i++) {
        var possibleDate = new Date("".concat(months[i], "/").concat(number));
        possibleDate.setHours(0, 0, 0, 0);
        isValid =
            possibleDate != "Invalid Date" &&
                dayjs("".concat(months[i], "/").concat(number < 10 ? "0" : "").concat(number), "YYYY/MM/DD").format("YYYY/MM/DD") ===
                    "".concat(months[i], "/").concat(number < 10 ? "0" : "").concat(number) &&
                possibleDate >= startDt &&
                possibleDate <= endDt;
        if (isValid)
            break;
    }
    return isValid;
};
export var getAllWeekDayNamesBetweenDates = function (startDate, endDate) {
    var weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    var result = [];
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    while (startDate <= endDate) {
        var currentDay = weekdays[startDate.getDay()];
        if (!result.includes(currentDay))
            result.push(currentDay);
        // Move to the next day
        startDate.setDate(startDate.getDate() + 1);
    }
    return result;
};
export var customDateStart = function (startDateForAPI) {
    if (dayjs(startDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return startDateForAPI;
    }
    else {
        return (dayjs(startDateForAPI).format("YYYY-MM-DD") +
            "T00:00:00.000" +
            getTimeZoneInHours());
    }
};
export var customDateEnd = function (endDateForAPI) {
    if (dayjs(endDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return endDateForAPI;
    }
    else {
        return endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))
            ? dayjs(new Date()).format("YYYY-MM-DD") +
                "T".concat(dayjs().format("YYYY-MM-DD HH:mm:ss").split(" ")[1], ".000") +
                getTimeZoneInHours()
            : dayjs(endDateForAPI).subtract(1, "day").format("YYYY-MM-DD") +
                "T23:59:59.000" +
                getTimeZoneInHours();
    }
};
export var customDateEndReportsWA = function (endDate) {
    if (endDate.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        return (dayjs(new Date()).format("YYYY-MM-DD") +
            "T".concat(dayjs().format("YYYY-MM-DD HH:mm:ss").split(" ")[1], ".000") +
            getTimeZoneInHours());
    }
    else {
        return endDate;
    }
};
export var customDateStartUTCTimeZone = function (startDateForAPI) {
    var startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    return startDate;
};
export var customDateEndUTCTimeZone = function (endDateForAPI) {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        var endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
    else {
        var endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
};
export var customDateStartUTCTimeZoneZ = function (startDateForAPI) {
    if (dayjs(startDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return startDateForAPI;
    }
    var startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    startDate = startDate.split(" ").join("T") + ".000Z";
    return startDate;
};
export var customDateFormatStartAndEnd = function (date, zone) {
    if (dayjs(date).format("YYYY-MM-DD") == "Invalid Date") {
        return date;
    }
    var finalDate = date.split("T")[0] + (zone == "0" ? " 00:00:00" : " 23:59:59");
    finalDate = dayjs(finalDate).format("YYYY-MM-DD HH:mm:ss");
    finalDate =
        finalDate.split(" ").join("T") + (zone == "0" ? ".000Z" : ".999Z");
    return finalDate;
};
export var customDateStartUTCTimeZoneZDetails = function (startDateForAPI) {
    var startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    startDate = startDate.split(" ").join("T") + ".000Z";
    return startDate;
};
export var customDateEndUTCTimeZoneZ = function (endDateForAPI) {
    if (dayjs(endDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return endDateForAPI;
    }
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        var endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
    else {
        var endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
};
export var customDateEndUTCTimeZoneZDetails = function (endDateForAPI) {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        var endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
    else {
        var endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
};
export var getLocalFormattedDate = function (date, dateFormat, timeFormat) {
    if (dateFormat === void 0) { dateFormat = "YYYY-MM-DD"; }
    if (timeFormat === void 0) { timeFormat = "HH:mm:ss"; }
    if (new Date(date) == "Invalid Date") {
        return date;
    }
    else {
        return dayjs(date)
            .utc("z")
            .local()
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format("".concat(dateFormat, " ").concat(timeFormat));
    }
};
export var getLocalFormattedDate24Hr = function (date, dateFormat, timeFormat) {
    if (dateFormat === void 0) { dateFormat = "YYYY-MM-DD"; }
    if (timeFormat === void 0) { timeFormat = "HH:mm:ss"; }
    if (new Date(date) == "Invalid Date") {
        return date;
    }
    else {
        return dayjs(date)
            .utc("z")
            .local()
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format("".concat(dateFormat, " ").concat(timeFormat));
    }
};
export var customDateStartWithoutTz = function (startDateForAPI) {
    var startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).format("YYYY-MM-DD HH:mm:ss");
    return startDate;
};
export var customDateEndWitoutTz = function (endDateForAPI) {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        var endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
    else {
        var endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
};
export var getFormattedMonthForInvoice = function (month) {
    if (!month)
        return "";
    try {
        return dayjs(new Date(month)).format("YYYY-MM");
    }
    catch (e) {
        return month;
    }
};
export function convertISOToCustomFormat(dates) {
    var sDate = dates.sDate, eDate = dates.eDate;
    var isValidDate = function (date) { return dayjs(date).isValid(); };
    var formattedDates = {
        sDate: isValidDate(sDate)
            ? "".concat(dayjs(sDate).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
            : "",
        eDate: isValidDate(eDate)
            ? "".concat(dayjs(eDate)
                .subtract(1, "day")
                .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
            : "",
    };
    return formattedDates;
}
export var formatTime = function (timestamp) {
    return timestamp && !isNaN(timestamp)
        ? dayjs(new Date(parseInt(timestamp))).format("YYYY-MM-DD hh:mm:ss A")
        : "NA";
};
var normalizeQuartzCron = function (expr) {
    var parts = expr.trim().split(/\s+/);
    while (parts.length < 6) {
        parts.unshift("0"); // add prefix "0"
    }
    return parts.join(" ");
};
// function cronToLocalTimeString(exp, timeFormat) {
//   // First get the standard description
//   let expr = normalizeQuartzCron(exp);
//   let description = cronstrue.toString(expr, {
//     verbose: true,
//     use24HourTimeFormat: true,
//   });
//   // Find all time patterns (HH:MM) in the description
//   const timeRegex = /(\d{1,2}):(\d{2})(?::(\d{2}))?/g;
//   let match;
//   const originalStr = description;
//   while ((match = timeRegex.exec(originalStr)) !== null) {
//     const [utcTime, hours, minutes, seconds] = match;
//     // Create a Day.js object in UTC
//     const utcDate = dayjs
//       .utc()
//       .hour(isNumber(hours) ? parseInt(hours) : 0)
//       .minute(isNumber(minutes) ? parseInt(minutes) : 0)
//       .second(isNumber(seconds) ? parseInt(seconds) : 0)
//       .millisecond(0);
//     // Convert to local time
//     const localTime = utcDate.local().format(timeFormat);
//     // Replace in description
//     description = description.replace(utcTime, localTime);
//   }
//   return description;
// }
// export const parseCron = (exp, timeFormat) => {
//   try {
//     // test expresssions
//     // exp = "00 37 15 14 08 ? 2025,00 37 15 15 08 ? 2025,00 37 15 16 08 ? 2025";
//     // exp = "0 4 7 7,8 * ?,0 3 6 7,8 * ?";
//     // @todo: remove comma separator from api response & provide a unique character as separator as comma is valid in quartz cron expression
//     let exps = exp.split(",");
//     let parsed = [];
//     let cronExpres = "";
//     for (let i = 0; i < exps.length; i++) {
//       cronExpres += exps[i];
//       if (cronExpres.split(" ").length < 6) {
//         cronExpres += ",";
//         continue;
//       }
//       parsed.push(cronToLocalTimeString(cronExpres, timeFormat));
//       cronExpres = "";
//     }
//     return parsed.join("\n\n");
//   } catch (err) {
//     console.error("error while parsing cron exp: ", exp, err);
//     return "-";
//   }
// };
function cronToLocalTimeString(exp, timeFormat) {
    var expr = normalizeQuartzCron(exp);
    var description = cronstrue.toString(expr, {
        verbose: true,
        use24HourTimeFormat: true,
    });
    // Replace each HH:mm(:ss) in description with local time
    description = description.replace(/(\d{1,2}):(\d{2})(?::(\d{2}))?/g, function (_, h, m, s) {
        var utcDate = dayjs
            .utc()
            .hour(isNumber(h) ? parseInt(h) : 0)
            .minute(isNumber(m) ? parseInt(m) : 0)
            .second(isNumber(s) ? parseInt(s) : 0)
            .millisecond(0);
        return utcDate.local().format(timeFormat);
    });
    return description;
}
export var parseCron = function (exp, timeFormat) {
    if (timeFormat === void 0) { timeFormat = "HH:mm:ss"; }
    try {
        var exps = exp.split(",");
        var parsed = [];
        var cronExpres = "";
        for (var i = 0; i < exps.length; i++) {
            cronExpres += exps[i];
            if (cronExpres.split(" ").length < 6) {
                cronExpres += ",";
                continue;
            }
            parsed.push(cronToLocalTimeString(cronExpres, timeFormat));
            cronExpres = "";
        }
        return parsed.join("\n\n");
    }
    catch (err) {
        console.error("error while parsing cron exp: ", exp, err);
        return "-";
    }
};
